module.exports = __webpack_public_path__ + "img/Square_1.72dd549e.jpg";